import React from 'react';
import className from 'classnames';
// import TextEditor from './TextEditor';
import _ from 'lodash';
import HttpClient from 'services/HttpClient';
import {inject, observer} from 'mobx-react';
import {withRouter} from "react-router-dom";
import NO_AVA from 'styles/img/no-ava-big.png'
import {linkComponentDecorator} from 'blocks/LinkRenderComponent';
import FilePreview from 'components/create_workshop/create_module/create_question/FilePreview';
import {TARGET_FILE_MAX_SIZE, TARGET_FILE_CONTENT_TYPES, PROVIDER} from '../../constants';
import { EditorState, ContentState } from 'draft-js';
// import htmlToDraft from 'html-to-draftjs';
// import { convertToRaw } from 'draft-js';
// import draftToHtml from 'draftjs-to-html';
import AVERAGE_ICON from 'styles/img/average.svg';
import GOOD_ICON from 'styles/img/good.svg';
import EXELENT_ICON from 'styles/img/excellent.svg';
import {TRAINEE} from 'components/providers/online_workshop_details/constants';
import OnlineWorkshopService from 'services/OnlineWorkshopService';
import Modal from 'react-modal';
import QuillEditor from 'components/create_workshop/QuillEditor';

const SET_ANSWER = '/api/v1/answers/set_result';


@withRouter
@inject('workshopDetails')
@inject('alert')
@inject('user')
@observer
export default class Form extends React.Component {

  constructor(props){
    super(props);
    this.fileKey = 1;
  }

  state = {active: false,
    openedModal: false,
    hasError: false,
    response: {text: '', documents: [], attachments_attributes: [], status: true }};



  reset = () => {
    if(this.state.response.id)
      this.props.handleClose();
    this.setState({response: {text: '', documents: [], attachments_attributes: [], status: true }, active: false})
  };

  componentWillReceiveProps = newProps => {
    if(newProps.response) {
      // let newText = new OnlineWorkshopService().htmlToDrafJs(newProps.text);
      // this.setState({active: true, response: _.assign({}, newProps.response, { text: newText } )});

      this.setState({active: true, response: newProps.response});
    }
    else
      this.setState({active: newProps.active})
  };


  componentDidMount = () => {
    let newProps = this.props;
    if(newProps.response) {
      let status = newProps.response.status === 'question_completed';
      // let newText = new OnlineWorkshopService().htmlToDrafJs(newProps.response.text || '');
      // this.setState({active: true, response: _.assign({}, newProps.response, { text: newText,status: status } )});

      let newText = newProps.response.text || '';
      this.setState({active: true, response: _.assign({}, newProps.response, { text: newText,status: status } )});

    }
  };

  handleChange = data => {
    // let newState = _.assign({}, this.state.response, data);
    this.setState({
      response: {
        ...this.state.response,
        text: data
      }
    })
  };


  addFile = data => {
    let documents = _.assign([],this.state.response.documents);
    documents.push(data);
    let newState = _.assign({}, this.state.response, {documents: documents});
    this.setState({response: newState});
  };

  activateForm = () => {
    this.setState({active: true})
  };

  addAttachments = e => {
      let file = e.target.files[0];
      // console.log(this.state.response.attachments.length)
      let attachemn = this.state.response.attachments ? this.state.response.attachments : []
      if((this.state.response.attachments_attributes.length + attachemn.length) >= 3){
        this.props.alert.error('You can`t add more than 3 files');
        return;
      }
      if(file.size > TARGET_FILE_MAX_SIZE || !TARGET_FILE_CONTENT_TYPES.includes(file.type)){
        this.props.alert.error('File is too big or content type is not correct')
      }
      else {
        if (e.target.files && e.target.files[0]) {
          let reader = new FileReader();
          reader.onload = e => {
            this.fileKey++;
            let newFile = _.assign({
              document: file,
              file_name: file.name,
              file_size: file.size,
              key: this.fileKey
            });
            {
              let attachments = this.state.response.attachments_attributes;
              attachments.push(newFile);
              let newState = _.assign({}, this.state.response, {attachments_attributes: attachments});
              this.setState({response: newState});
            }
          };
          reader.readAsDataURL(file);
        }
      }
  };

  submit = () => {
    let data = _.assign({}, this.state.response);
    if(data.text) {
      // _.assign(data, {text: draftToHtml(convertToRaw(data.text.getCurrentContent()))});
      if(data.text && data.text.trim() === '<p></p>')
        data.text = null;

      if(data.text && data.text.length > 20000){
        this.setState({hasError: 20000});
        return
      }
    }
    let formdata = new FormData();
    data.documents.forEach(e => {
      if(data.text.includes(e.src)){
        formdata.append('text[]documents[]file',e.file);
        formdata.append('text[]documents[]src',e.src)
      }
    });
    if(this.state.response)
      formdata.append('answer_id', this.state.response.id);
    formdata.append('transaction_id', this.props.transaction_id);
    formdata.append('text[]text', data.text);
    data.attachments_attributes.forEach(e => {
      formdata.append('attachments_attributes[]document',e.document);

    });
    formdata.append('question_id',this.props.question_id);
    formdata.append('workshop_id',this.props.workshopDetails.workshop.id);
    if(!data.text) {
      this.props.alert.error('Response cant be empty');
      return;
    }
    if(this.props.workshopDetails.role === TRAINEE)
      new HttpClient().multipart('/api/v1/answers',formdata, this.state.response.id ? 'PUT' :'POST').then(data => {
        this.props.alert.success('Response successfully added');
        this.props.workshopDetails.updateModule(data.body.workshop_module);
        if(this.props.workshopDetails.workshop.status === 'workshop_completed') {
          this.props.alert.success('Workshop is complete and the CPD cert is available');
        }
        if(!this.state.response.id)
         this.reset();
        else this.props.handleClose();
      });
    if(this.props.workshopDetails.role === PROVIDER){
      formdata.append('status', this.state.response.status ? 'success' : 'failed');
      formdata.append('user_id',this.props.workshopDetails.workshop.traine.id);
      new HttpClient().multipart(this.state.response.id ? '/api/v1/answers' : SET_ANSWER,formdata, this.state.response.id ? 'PUT' :'POST').then(data => {
        this.props.alert.success('Response successfully added');
        if(!this.state.response.id)
          this.props.workshopDetails.updateModule(data.body.data.workshop_module);
        else
          this.props.workshopDetails.updateModule(data.body.workshop_module);
        if(!this.state.response.id )
          this.reset();
        else this.props.handleClose();
      });
    }
  };

  // htmlToDrafJs = html => {
  //   const {contentBlocks, entityMap} = htmlToDraft(html);
  //   const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
  //   return EditorState.createWithContent(contentState);
  // };

  deleteFileFromServer = id => {
    this.setState({openedModal: true, deleteId: id})
  };

  deleteFile = data => {
    let newAttachments = _.assign([],this.state.response.attachments_attributes);
    newAttachments = _.filter(newAttachments, (el => el.key !== data) );
    let newState = _.assign({}, this.state.response, {attachments_attributes: newAttachments});
    this.setState({response: newState});
  };

  handleChangeSwitcher = e => {
    let newState = _.assign({}, this.state.response, {status: e.target.checked});
    this.setState({response: newState})
  };

  setShortResponse = key => {
    if(key == this.props.last_answer_key)
      return

    let formdata = new FormData();
    formdata.append('transaction_id', this.props.transaction_id);
    formdata.append('question_id',this.props.question_id);
    formdata.append('answer_score',key);
    formdata.append('workshop_id',this.props.workshop_id);
    formdata.append('status','success');
    formdata.append('user_id',this.props.workshopDetails.workshop.traine.id);
    new HttpClient().multipart(SET_ANSWER,formdata,'POST').then(data => {
      this.props.alert.success('Response successfully added');
      this.props.workshopDetails.updateModule(data.body.data.workshop_module);
      this.reset();
    });
  };

  deleteObject = () => {
    const deleteID = this.state.deleteId;
    new HttpClient().put('/api/v1/answers/remove_attachments',
      {answer_id: this.state.response.id, attachment_id: this.state.deleteId }).then((data) => {
      this.props.alert.success('File successully deleted');
      let newAttachments = _.assign([], this.state.response.attachments.slice());
      newAttachments = _.filter(newAttachments, el => { return  el.id !== deleteID } );
      let newState = _.assign({}, this.state.response, {attachments: newAttachments});
      this.setState({response: newState, deleteId: null,openedModal: false});
    })
  };

  decline = () => {
    this.setState({openedModal: false})
  };

  render(){
    const workshop = this.props.workshopDetails.workshop;
    let ava;
    if(workshop.access_type === 'purchased')
      ava = workshop.provider_logo_url;
    else
      ava = this.props.workshopDetails.workshop.traine.avatar_url;
    return (
      <div className={className('answers')}>


        <Modal
          isOpen={this.state.openedModal}
          closeTimeoutMS={100}
          contentLabel="Modal"
        >
          <h1>Are you sure you want to delete this file?</h1>
          <div className="modal-permissions-button">
            <div className="workshop-creator-sidebar-publish">
              <span className="btn prime bordered" onClick={this.deleteObject}>Accept</span></div>
            <div className="workshop-creator-sidebar-publish" style={{marginLeft: 15}}>
              <span className="btn prime bordered red" onClick={this.decline}>Decline</span></div>
          </div>
        </Modal>


        <div className={className('answer-item border-response-editor',{nonDispayed: !this.state.active})}>
          <div className="answer-item-head">
            <div className="answer-item-avatar">
              { ava ?
                <img src={ava} alt="avatar"/>:
                <img src={NO_AVA} alt="avatar"/>

              }
            </div>
            <div className="answer-item-info">
              <p className="name">
                {workshop.access_type === 'purchased' ?
                  workshop.provided_by : workshop.traine.full_name
                }
              </p>
              <p className="type">Response</p>
            </div>
          </div>
          <div className={className({'col-12': true, 'has-error': this.state.hasError }) }>
            <div className="accordion-content-block answer-item-content">

              <QuillEditor
                showToolbar={true}
                onChange={this.handleChange}
                value={this.state.response.text}
                placeholder={'Response editor...'}
              />

              {/* <TextEditor text={this.state.response.text}
                          onChange={this.handleChange}
                          name="text"
                          customDecorators={[linkComponentDecorator]}
                          addFile={this.addFile}/> */}

              <span className="error-text" style={{color: '#e91e63'}}>{this.state.hasError && 'Maximum characters allowed: 20,000'}</span>

            </div>

            <div className={className('row')} style={{float: 'right',marginRight: 10, marginTop: 10}}>
              <div className={className('col-1',{nonDispayed: this.props.workshopDetails.role === TRAINEE})}>
                <div className="accordion-content-block">
                  {/*<div className="switcher" style={{display: 'inline-flex'}}>*/}
                    {/*<p className="complete-button-responce" >Completed</p>*/}
                    {/*<input type="checkbox"*/}
                           {/*id={`modulesSwitcher${this.props.question_id}`}*/}
                           {/*value={this.state.response.status}*/}
                           {/*onChange={this.handleChangeSwitcher}*/}
                           {/*checked={this.state.response.status}/>*/}
                    {/*<label htmlFor={`modulesSwitcher${this.props.question_id}`} style={{bottom: -4}}/>*/}
                  {/*</div>*/}
                </div>
              </div>
            </div>
              <div className='row'>
              <div className="col-12">
                <div className="accordion-content-block">
                  <ul className="file-list editing">
                    {
                      this.state.response.attachments && this.state.response.attachments.map( el =>
                      {
                        let data = {file_name: el.document_file_name, file_size: el.document_file_size, key: el.id};
                        return <FilePreview el={data} key={el.id} deleteFile={this.deleteFileFromServer}/>
                      })
                    }

                    {
                      this.state.response.attachments_attributes.map( el =>
                        {
                          this.fileKey++;
                        return <FilePreview el={el} key={this.fileKey} deleteFile={this.deleteFile}/>
                    })
                        }
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        { this.state.active ?
          <div className="answer-item-edit btn-holder" style={{marginBottom: 30}}>
            {this.state.response.attachments_attributes.length >= 3 ? null :
              <span className='upload-icon-form' style={{
                marginRight: 15
              }}
              >
                <div className="upload-file-responcse-container">
                  <label onChange={this.addAttachments} htmlFor="responceForm">
                    <span className="label">Upload File</span>
                    <span className="tooltip">
                      <span>Upload a File</span>
                      <span>PDF / Word only</span>
                    </span>
                  <svg width="14" height="17">
                    <path fillRule="evenodd" d="M4 13V7H0L7-.001 13.999 7H10v6H4m-4 4v-2h13.999v2H0z" opacity=".541"/>
                    </svg>
                    <input type='file' id="responceForm" className="nonDispayed"/>
                    </label>
                  </div>
            </span>
            }
            {[ <span className="btn bordered empty grey-empty submit-answer-hoover"
                  onClick={this.submit}
                     key={1}
            style={{padding: '10px 15px', color: '#1ea2e8', backgroundColor: 'white', borderColor: '#1ea2e8', marginRight: 10}}>
              submit
            </span>,
            <span className="btn bordered empty grey-empty submit-answer-hoover"
                  onClick={this.reset}
                  style={{padding: 10}}
                  key={3}>
              close
            </span>]}
          </div>:

          <div className="btn-holder cutomize-btn-holder">
            {this.props.workshopDetails.role === PROVIDER && this.props.workshopDetails.workshop.modules[this.props.moduleId].status === 'module_completed' &&
              <div className='response-icon-container'>
                <img src={EXELENT_ICON} className='response-icon' onClick={e => this.setShortResponse(2)}/>
                <img src={AVERAGE_ICON} className='response-icon' onClick={e => this.setShortResponse(0)}/>
                <img src={GOOD_ICON} className='response-icon' onClick={e => this.setShortResponse(1)}/>
              </div>
            }

            { this.props.workshopDetails.workshop.modules[this.props.moduleId] && this.props.workshopDetails.workshop.modules[this.props.moduleId].status !== 'module_completed' &&
              <span className="btn prime bordered" style={{marginBottom: 30}} onClick={this.activateForm}>
              {this.props.workshopDetails.role === TRAINEE ? 'add response' : 'Add Feedback'}
            </span>
            }

            { this.props.workshopDetails.role === PROVIDER && this.props.workshopDetails.workshop.modules[this.props.moduleId] && this.props.workshopDetails.workshop.modules[this.props.moduleId].status === 'module_completed' &&
              <span className="btn prime bordered" style={{marginBottom: 30}} onClick={this.activateForm}>
              {this.props.workshopDetails.role === TRAINEE ? 'add response' : 'Add Feedback'}
            </span>
            }
            </div>
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/providers/online_workshop_details/question/responces/Form.jsx